module.exports = __webpack_public_path__ + "img/gas-natural.4541ba84.svg";